import { z } from "zod";

export const createProfileSchema = (t: any) =>
  z.object({
    name: z.string().min(1, { message: t("forms:errors.nameRequired") }),
    headline: z
      .string()
      .max(300, { message: t("forms:errors.headlineMax") })
      .optional(),

    locale_code: z.string({ required_error: t("forms:errors.localeRequired") }).refine(
      (data) => {
        return data;
      },
      {
        message: t("forms:errors.localeRequired"),
      },
    ),
    youtube_url: z
      .string()
      .regex(
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})(?:\S+)?/,
        { message: t("forms:errors.invalidYtUrl") },
      )
      .optional(),
    certificates: z
      .array(
        z.object({
          credential_id: z.string().optional(),
          credential_url: z
            .string()
            .url({
              message: t("forms:errors.invalidUrl"),
            })
            .optional()
            .or(z.literal("")),
          description: z.string().optional(),
          expiration_date: z.string().optional(),
          issue_date: z.string().optional(),
          issuing_organization: z.string(),
          name: z.string(),
        }),
      )
      .optional(),
    education: z
      .array(
        z.object({
          degree: z.string().optional(),
          description: z.string().optional(),
          end_date: z.string().optional(),
          field_of_study: z.string().optional(),
          institution_name: z.string(),
          start_date: z.string().optional(),
        }),
      )
      .optional(),
    languages: z
      .array(
        z.object({
          id: z.string(),
          proficiency: z.string(),
        }),
      )
      .min(1, {
        message: t("forms:errors.languagesRequired"),
      }),
    subjects: z
      .array(
        z.object({
          id: z.string(),
          curriculum_levels: z.array(z.string()),
        }),
      )
      .min(1, {
        message: t("forms:errors.subjectsRequired"),
      }),
  });

export type CreateProfileFormData = z.infer<ReturnType<typeof createProfileSchema>>;
